exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#document-view td[_v-3e3e929e]{border-width:0 0 1px;border-style:solid;border-color:#efefef}@media (max-width:767px){#document-view td[_v-3e3e929e]{padding:16px 16px 15px}}#document-view td .title p[_v-3e3e929e]{color:#0b4a7e}@media (max-width:767px){#document-view td .title p[_v-3e3e929e]{margin-bottom:4px}}@media (max-width:767px){#document-view .container[_v-3e3e929e]{margin-top:0}}.banner[_v-3e3e929e]{background-image:url(" + require("./images/img-latest.jpg") + ")}.banner.visible-xs[_v-3e3e929e]{padding-bottom:52%;background-size:cover;background-position:50%}.banner.hidden-xs[_v-3e3e929e]{padding-bottom:32%;background-size:100%;background-position:0 80px;background-attachment:fixed;margin-bottom:40px}@media (max-width:767px){.banner[_v-3e3e929e]{margin-top:52px}.banner .banner[_v-3e3e929e]{padding-bottom:52%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-3e3e929e&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./assets/component/document/document-page.vue
// module id = 299
// module chunks = 0